module.exports = __webpack_public_path__ + "img/part3-1.4d253d9e.png";